module.exports = __webpack_public_path__ + "img/quick-icon02.059cbbc8.png";